<era-security-membership-list-ui [editEnabled]="editEnabled"
                                 [user]="user()"
                                 (toggleEditEvent)="toggleEditEvent()"
                                 (addGroupEvent)="addGroupEvent()">
</era-security-membership-list-ui>